// extracted by mini-css-extract-plugin
export var modalBody = "ImageViewerModal-module--modal-body--eN6jR";
export var modalContent = "ImageViewerModal-module--modal-content--IaXbD";
export var modalHeader = "ImageViewerModal-module--modal-header--zFD-E";
export var modalImg = "ImageViewerModal-module--modal-img--MNZWH";
export var spinnerContainer = "ImageViewerModal-module--spinner-container--8keKH";